import i from './forget-password.container';

export default i;
